module.exports = __webpack_public_path__ + "static/img/icon_script.07c7423e.svg";